import React from "react";
import PropTypes from "prop-types";
import { noop } from "utils";
import classNames from "utils/class-names";

function Pagination({
  totalPages,
  currentPage,
  loadPreviousPage = noop, // Set default value here
  loadNextPage = noop, // Set default value here
  loadFirstPage = noop, // Set default value here
  loadLastPage = noop,
  disablePrev = false, // Set default value here
  disableNext = false, // Set default value here
  disableFirst = false,
  disableLast = false,
}) {
  if (totalPages < 2) return null;

  return (
    <div className="paginationWrap">
      <div className="left">
        <span className="fs14" data-testid="page-count">
          Page {currentPage} of {totalPages}
        </span>
      </div>

      <nav aria-label="Page navigation example">
        <ul className="pagination">
          <li
            className={classNames("page-item", {
              disabled: disableFirst,
            })}
          >
            <button
              className="page-link"
              onClick={loadFirstPage}
              disabled={disableFirst}
            >
              First Page
            </button>
          </li>
          <li
            className={classNames("page-item", {
              disabled: disableLast,
            })}
          >
            <button
              className="page-link"
              onClick={loadLastPage}
              disabled={disableLast}
            >
              Last Page
            </button>
          </li>
          <li
            className={classNames("page-item", {
              disabled: disablePrev,
            })}
          >
            <button
              className="page-link"
              onClick={loadPreviousPage}
              disabled={disablePrev}
            >
              Prev
            </button>
          </li>
          <li
            className={classNames("page-item", {
              disabled: disableNext,
            })}
          >
            <button
              className="page-link"
              onClick={loadNextPage}
              disabled={disableNext}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}

Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  loadPreviousPage: PropTypes.func,
  loadNextPage: PropTypes.func,
  disablePrev: PropTypes.bool,
  disableNext: PropTypes.bool,
};

export default Pagination;
